import React from 'react';
import Checkbox from 'src/components/Checkbox/Checkbox';
import CategoryPill from 'src/components/CategoryPill/CategoryPill';
import { IServiceRequest } from 'src/services/api/ServiceRequestDashboard/apiContracts';
import './service-request-row.scss';

interface ServiceRequestRowProps {
  serviceRequest: IServiceRequest;
  isChecked: boolean;
  onToggle: (id: string) => void;
}

const INTERNAL_PILL_COLOR: string = 'var(--color-status-negative)';
const INTERNAL_PILL_TEXT_COLOR: string = '#FFFFFF';
const EXTERNAL_PILL_COLOR: string = 'var(--color-status-positive)';
const EXTERNAL_PILL_TEXT_COLOR: string = '#FFFFFF';

const STATUS_PILL_COLOR: string = '#637381';
const STATUS_PILL_TEXT_COLOR: string = '#FFFFFF';

const ServiceRequestRow = ({
  serviceRequest,
  isChecked,
  onToggle,
}: ServiceRequestRowProps) => {
  const ticketNumber: string =
    serviceRequest.ticketNumber ?? serviceRequest.number ?? '—';

  const subject: string = serviceRequest.subject?.trim() || 'No subject';

  const propertyName: string = serviceRequest.propertyName ?? '—';

  const isInternalOnly: boolean = serviceRequest.isExternallyVisible === false;

  return (
    <label className="service-request-row">
      <div className="service-request-row-checkbox">
        <Checkbox
          checked={isChecked}
          value={isChecked}
          onChange={() => onToggle(serviceRequest.id)}
        />
      </div>

      <div className="service-request-row-identity">
        <div className="service-request-row-number">{ticketNumber}</div>
        <div className="service-request-row-subject">{subject}</div>
        <div className="service-request-row-visibility">
          {isInternalOnly ? (
            <CategoryPill
              text="Internal"
              color={INTERNAL_PILL_COLOR}
              textColor={INTERNAL_PILL_TEXT_COLOR}
              size="small"
              iconGlyph="eye-slash"
              iconWeight="solid"
            />
          ) : (
            <CategoryPill
              text="External"
              color={EXTERNAL_PILL_COLOR}
              textColor={EXTERNAL_PILL_TEXT_COLOR}
              size="small"
              iconGlyph="eye"
              iconWeight="solid"
            />
          )}
        </div>
      </div>

      <div className="service-request-row-status">
        {serviceRequest.status && (
          <CategoryPill
            text={serviceRequest.status}
            color={STATUS_PILL_COLOR}
            textColor={STATUS_PILL_TEXT_COLOR}
            size="small"
          />
        )}
      </div>

      <div className="service-request-row-property">{propertyName}</div>
    </label>
  );
};

export default ServiceRequestRow;